import { isSuccess } from "@dgs/core";
import { useQueryClient } from "@tanstack/react-query";
import { FC } from "react";
import { companyService } from "../../shared/api/companyService";
import { ICompanyUpdateResource, TagIndexResource } from "../../shared/types";
import { ViewTagsSection } from "../../shared/view";

interface Props {
	company: ICompanyUpdateResource;
}

export const CompanyViewTagsSection: FC<Props> = ({ company }) => {
	const queryClient = useQueryClient();

	const handleUpdateTags = async (tags: TagIndexResource[]) => {
		const response = await companyService.updateTags(
			company.id,
			tags.map((x) => x.id),
		);
		await queryClient.invalidateQueries({ queryKey: companyService.showKey(company.id) });
		await queryClient.invalidateQueries({ queryKey: companyService.listKey });

		return isSuccess(response);
	};

	return <ViewTagsSection tags={company.tags} onUpdateTags={handleUpdateTags} />;
};
